<div class="dialog">
  <div>
    @if (data.title === 'Info') {
      <span class="material-icons">info</span>
    }
    @if (data.title === 'Warning') {
      <span class="material-icons">warning</span>
    }
    @if (data.title === 'Error') {
      <span class="material-icons">error</span>
    }
    <span mat-dialog-title>{{ data.title }}</span>
  </div>

  <mat-dialog-content style="margin-bottom: 20px;">
    <p>{{ data.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="success" (click)="onOk()">OK</button>
  </mat-dialog-actions>
</div>

